import React from 'react';

const reporting = () => {
  return <div>{'reporting'}</div>;
};

export default reporting;
